import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import { Provider } from 'react-redux';
import { ArrowIcon } from '@chegg-ui/horizon-icons';
import MfaByEmail from '@chegg/mfa-by-email';
import { abortPolling } from '@chegg/one-auth-sdk';
import { interactionBackButtonModal, interactionRioEventCloseModal } from "../../common/rio/rio";
import { Router } from "../Router";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getStore } from "../../store";
import { isValidRoute } from "../../store/orchestrator/utils/orchestrator.utils";
import { setIsToastOpen } from "../../store/slices/errorModal";
import { routerSlice } from "../../store/slices/router";
import { getCallback } from "../../utils/callbacks";
import { cleanup } from "../../utils/cleanup";
import { getTexts } from "../../utils/texts";
// I cant figure out why this specific import fails if using alias so using direct path <arieh@chegg.com>

import { Toast } from "../Toast/Toast";
import { GoBackLinkSC, MfaDialogSC, ModalSC } from "./MfaDialog.styles";
import { useSetProps } from "./useSetProps";
export var MfaDialog = function MfaDialog(props) {
  var _useAppSelector;
  useSetProps(props);
  var currentRoute = useAppSelector(function (state) {
    return state.router.current_route;
  });
  var _ref = (_useAppSelector = useAppSelector(function (state) {
      return state.error.toast;
    })) !== null && _useAppSelector !== void 0 ? _useAppSelector : {},
    isToastOpen = _ref.isToastOpen,
    toastTitle = _ref.toastTitle,
    toastMessage = _ref.toastMessage,
    toastType = _ref.toastType,
    ctaText = _ref.ctaText,
    _ctaArg = _ref.ctaArg;
  var dispatch = useAppDispatch();
  var byEmailRoute = currentRoute == 'mfa-by-email';
  var onCloseCb = useCallback(function () {
    interactionRioEventCloseModal(currentRoute);
    cleanup();
  }, [currentRoute]);
  var backButtonCb = useCallback(function () {
    interactionBackButtonModal(currentRoute);
    dispatch(routerSlice.actions.changeRoute('/'));
    abortPolling();
  }, [dispatch, currentRoute]);
  return /*#__PURE__*/React.createElement(ModalSC, {
    id: 'mfa-dialog-container',
    "aria-label": 'mfa-dialog-container',
    isOpen: true,
    onClose: onCloseCb,
    contentOverflow: false,
    byEmail: byEmailRoute,
    notifBanner: /*#__PURE__*/React.createElement(Toast, {
      "data-test": "mfa_by_app_notification_banner",
      variant: toastType,
      isOpen: isToastOpen,
      title: toastTitle !== null && toastTitle !== void 0 ? toastTitle : '',
      message: toastMessage !== null && toastMessage !== void 0 ? toastMessage : '',
      ctaText: ctaText,
      ctaArg: function ctaArg() {
        return toastCta(_ctaArg);
      }
    })
  }, renderContent(), getBackButton());
  function getBackButton() {
    if (!['qr', 'push_sent', 'mfa-by-email'].includes(currentRoute)) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    return /*#__PURE__*/React.createElement(GoBackLinkSC, {
      screenReaderOnlyText: 'Go Back',
      "data-test": "go-back",
      onClick: backButtonCb,
      byEmail: byEmailRoute,
      "aria-label": getTexts().mfaDialog.backButtonLabel
    }, /*#__PURE__*/React.createElement(ArrowIcon, {
      pointing: 'left'
    }));
  }
  function toastCta(ctaArg) {
    if (typeof ctaArg === 'string' && isValidRoute(ctaArg)) {
      dispatch(setIsToastOpen({
        isOpen: false
      }));
      dispatch(routerSlice.actions.changeRoute(ctaArg));
    } else if (typeof ctaArg === 'function') {
      ctaArg();
    }
  }
  function renderContent() {
    if (props.showMfaByApp === false || byEmailRoute || !props.authParams.cheggMfaToken) {
      var mfaParams = _objectSpread(_objectSpread({}, props.authParams), {}, {
        mfaToken: props.authParams.auth0Token
      });
      return /*#__PURE__*/React.createElement(MfaByEmail, _extends({}, mfaParams, {
        userUuid: props.authParams.uuid,
        onSuccessCb: function onSuccessCb(t) {
          return getCallback('onSuccess')(t);
        },
        onMfaClose: onCloseCb,
        onLoadingCb: function onLoadingCb() {
          return getCallback('onLoading')();
        },
        noDialog: true
      }));
    }
    return /*#__PURE__*/React.createElement(MfaDialogSC, {
      "data-test": 'mfa-dialog'
    }, /*#__PURE__*/React.createElement(Router, null));
  }
};
/* istanbul ignore next */
var MfaDialogWrapper = function MfaDialogWrapper(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: getStore()
  }, /*#__PURE__*/React.createElement(MfaDialog, props));
};
MfaDialogWrapper.displayName = 'MfaDialog';
export default MfaDialogWrapper;